module.exports = __webpack_public_path__ + "img/logo.e6b2369b.svg";